var shvenergy = shvenergy || {};

shvenergy.search.filters = (function ($) {
    "use strict";

    function updateFiltersByType() {
        $(".search__dealerfilter.isActive").removeClass("isActive");
        $("[data-dealertype]").hide();
        $("[data-dealertype='" + shvenergy.search.dealer.getType() + "']").show();
    }


    function getOriginalSelectedUrlFilters() {
        var type = shvenergy.search.dealer.getType();
        const TAG_FILTER_NAME = `${type}-Tag`;
        let filterQuerystring = "";
        const currentFilters = document.querySelectorAll(`[data-filterwasdefaultchecked='true'][data-type='${TAG_FILTER_NAME}']`);
        currentFilters.forEach(function (filter) {
            filterQuerystring += "&filter=" + filter.dataset.queryparametername;
        });

        return filterQuerystring;
    }

    function resetFilters() {
        var form = $(".search__filter.search__pane");
        form[0].reset();


        setTimeout(function () {
            $("input[data-dealertypename]:checked").prop("checked", false);
            
            updateFilterCount();
        }, 100);

        if (window.history.pushState) {

            var urlWithoutFilters = removeUrlParameter(window.location.href, "&filter", "*");
            //console.log("urlWithoutFilters", urlWithoutFilters);

            var newUrl = urlWithoutFilters + window.location.hash;
            //console.log(newUrl);
            history.pushState(null, document.title, newUrl);
        }

        var bounds = shvenergy.maps.getBounds();
        var zoomLevel = shvenergy.maps.getZoom();
        shvenergy.search.dealer.searchByLocation(bounds, zoomLevel);
    }

    function getFilterCount() {
        var type = shvenergy.search.dealer.getType();
        return $("input[data-dealertypename='" + type + "']:checked").length;
    }

    const detectFilterButtonAvailability = () => {
        let currentDealerType = shvenergy.search.dealer.getType();
        const filterButton = document.querySelector(".search__filters.search__back--filter.search__controls__button-container");

        if(!$(".toggle[value='Cylinder']").data('hideavailablefiltersbutton') && currentDealerType === 'Cylinder' ){
            filterButton.style.display = "inline-flex";
        }
        if(!$(".toggle[value='Autogas']").data('hideavailablefiltersbutton') && currentDealerType === 'Autogas'){
            filterButton.style.display = "inline-flex";
        }

        if($(".toggle[value='Cylinder']").data('hideavailablefiltersbutton') && currentDealerType === 'Cylinder' ){
            filterButton.style.display = "none";
        }
        if($(".toggle[value='Autogas']").data('hideavailablefiltersbutton') && currentDealerType === 'Autogas'){
            filterButton.style.display = "none";
        }
    }

    function updateFilterCount() {
        const count = getFilterCount();
        
        if (count > 0) {
            $(".search__filter__number").show().text(getFilterCount());
        } else {
            $(".search__filter__number").hide();
        }

        detectFilterButtonAvailability();
    }

    //Helper function. Not exported at the bottom
    function removeUrlParameter(url, parameter, parameterValue = '') {
        var urlParts = url.split('?');

        if (urlParts.length >= 2) {
            // Get first part, and remove from array
            var urlBase = urlParts.shift();

            // Join it back up
            var queryString = urlParts.join('?');

            const params = new URLSearchParams("");
            params.append(parameter, parameterValue);

            var prefix = params.toString();
            var parts = queryString.split(/[&;]/g);

            // Reverse iteration as may be destructive
            for (var i = parts.length; i-- > 0;) {
                // Idiom for string.startsWith
                //console.log("parts[i]:", parts[i]);
                //console.log("prefix: ", prefix);
                if (parts[i] === prefix || (parts[i].includes("filter") && prefix.includes("*"))) {
                    parts.splice(i, 1);
                }
            }

            url = urlBase + '?' + parts.join('&');
        }

        return url;
    }

    function updateQueryStringFilters(filter) {
        const searchParams = new URLSearchParams(window.location.search);


        if (filter.dataset.queryparametername === undefined)
            return;

        var newUrl = "";
        if (filter.checked) {
            searchParams.append("filter", filter.dataset.queryparametername);
            const searchString = searchParams.toString().length > 0 ? '?' + searchParams.toString() : '';
            newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + searchString + window.location.hash;
            
        } else {
            newUrl = removeUrlParameter(window.location.href, "filter", filter.dataset.queryparametername);
        }

        if (window.history.pushState) {
            history.pushState(null, document.title, newUrl);
        }
    }

    return {
        updateFiltersByType: updateFiltersByType,
        resetFilters: resetFilters,
        getFilterCount: getFilterCount,
        updateFilterCount: updateFilterCount,
        updateQueryStringFilters: updateQueryStringFilters,
        getOriginalSelectedUrlFilters: getOriginalSelectedUrlFilters
    };

})(jQuery);